import React from "react";
import { connect } from "react-redux";
import { aemHostClient, eapiClient, taxonomyHostClient } from "../../../restClient";
import { Translations } from "../../../utils";
import { setAddresses } from "../../CaseBody/actions/actionCreator";
import CreateEntity, { CreateEntityForm, SowCreateEntityPageUrl } from "../../createASow/CreateEntity";
import { setDarkTitleBarContent } from "../../layouts/actions/actionCreator";
class CaptureCustomerBasicDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: this.props.activeEntity || {}
        }
    }
    componentWillMount() {
        if (this.props.activeEntity.agent) {
            let apiUrl = `/sowaddress/${this.props.activeEntity && this.props.activeEntity.id}`
            eapiClient(apiUrl)
                .then(({ data }) => {

                    this.setState({ addresses: data.responseData });
                    //this.getTaxanomyUrl();
                    this.props.setAddresses(data.responseData);
                });
        }
    }

    getTranslation = (word) => {
        return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    onFormSubmit = (e, apiUrl = `/sows/${this.props.activeEntity && this.props.activeEntity.id}/sow-basic-detail`) => {
        this.props.blockUi && this.props.blockUi()
        const payLoad = { ...this.state.formData }
        eapiClient(apiUrl, {
            method: 'PUT',
            data: JSON.stringify(payLoad)
        }).then(({ data }) => {
            if (data.responseData) {
                this.props.unBlockUi && this.props.unBlockUi()
                this.props.getSowDetails && this.props.getSowDetails()
                this.props.getTabStatus && this.props.getTabStatus()
                aemHostClient("/aemData/formData/json_dark-title-bar")
                    .then(({ data, status }) => {

                        let bodyHeading = this.props.sowEntities.filter(entity => {
                            return entity.agent
                        })
                        let transaltedText = Translations(data.par.static_text_darkTitleBar.exitSow, this.props.lang.currentLang.lang, this.props.lang.translatedData);
                        taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
                            .then(({ data }) => {
                                if (bodyHeading && bodyHeading[0] && bodyHeading[0].registeredName) {
                                    this.props.setDarkTitleBarContent(bodyHeading[0].registeredName, true, transaltedText, "icon icon-delete",
                                        this.props.owningCase, data.responseData.classificationNodes[0].associations);
                                }
                            })
                    });
            }
        })
    }

    setFieldValidationState = (e, isValid) => {
        return e
    }

    handleFormChange = (formData = {}) => {
        const sanitizedFormData = { ...formData }
        Object.keys(sanitizedFormData).map(key => typeof sanitizedFormData[key] === "string" ? sanitizedFormData[key] = sanitizedFormData[key].trim() : '')
        this.setState({ formData: sanitizedFormData })
    }

    render() {
        return (
            <React.Fragment>
                <CreateEntityForm
                    formJson={this.props.customerDetailsFormJson}
                    createEntityProps={{ ...this.props }}
                    onFormSubmit={this.onFormSubmit}
                    getTranslation={this.getTranslation}
                    setFieldValidationState={this.setFieldValidationState}
                    getFormData={this.handleFormChange}
                    entityList={this.props.sowEntities}
                    formData={this.state.formData}
                    productType="gls-sow-edit-entity"
                    saveButton={true}
                    history={this.props.history}
                    addresses={this.state.addresses}
                    activeEntity={this.props.activeEntity}
                    showLoaderOnFetchApiResource={true}
                    customer={this.props.customer}
                    isCustAck={this.props.isCustAck}
                    isRepeatingComponentWithSameResourceUrl={this.props.isRepeatingComponentWithSameResourceUrl}
                    cachedResourceData={this.props.cachedResourceData}
                ></CreateEntityForm>
            </React.Fragment>
        )
    }
}
const mapStateToProps = state => {
    return {
        sowEntities: (state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.entity) || [],
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setDarkTitleBarContent: (...args) => {
            dispatch(setDarkTitleBarContent(...args));
        },
        setAddresses: addresses => {
            dispatch(setAddresses(addresses));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureCustomerBasicDetails)


// WEBPACK FOOTER //
// ./src/components/SowBody/CustomerDetails/CaptureCustomerDetails.js